// Store API name and base URL in a config file
export const apiConfig = {
    apiName: 'api',  // This is the name of the API (from AWS API Gateway or similar)
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api',  // You can also store the base URL here
  };
  